<template>
  <div class="indexTeachers">
    <div class="classesTitle">
      <img src="../../assets/gold_teacher.png" />
      <h2>金牌讲师</h2>
    </div>
    <div class="teacherSwiper">
      <swiper :autoplay="swiperOptions.autoplay" :loop="swiperOptions.loop" :speed="swiperOptions.speed"
        :pagination="swiperOptions.pagination">
        <swiper-slide v-for="(group, index) of this.teacherList" :key="index">
          <!--一页最多8个，可以少，不能多-->
          <a v-for="(teacher, index) of group" :key="index" class="teacherItem">
            <img src="../../assets/teacher_bg.png" class="bg" />
            <img :src="teacher.avatar" class="teacherAvatar" />
            <b>{{teacher.name}}</b>
            <span>{{teacher.intro}}</span>
          </a>
        </swiper-slide>
      </swiper>
    </div>
  </div>
</template>

<script>
import { reactive } from "vue";
// 引入Swiper及子模块
import { Swiper, SwiperSlide } from 'swiper/vue';
import SwiperCore, { Autoplay, Pagination } from 'swiper';
import 'swiper/swiper.min.css';
import 'swiper/components/pagination/pagination.min.css';
SwiperCore.use([Autoplay, Pagination]);

// 引入请求类
import { getGoldTeacherList } from "../../server/index_main_gold_teacher";

export default {
  data() {
    return {
      teacherList: [],
    };
  },
  mounted() {
    this.fetchGoldTeacherList();
  },
  methods: {
    async fetchGoldTeacherList() {
      let result = await getGoldTeacherList();
      this.teacherList = result;
    },
  },
  components: {
    Swiper,
    SwiperSlide,
  },
  setup() {
    const swiperOptions = reactive({
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
      },
      loop: false,
      speed: 1000,
      pagination: {
        // el: "swiper-pagination",
        clickable: true,
        // bulletClass: "my-pagination-bullet",
        // bulletActiveClass: "my-pagination-bullet-active"
      },
    });
    return {
      swiperOptions,
    };
  },
};
</script>

<style>
.indexTeachers {
  padding-bottom: 110px;
  position: relative;
  z-index: 2;
}

.indexTeachers .classesTitle {
  width: 1200px;
  margin: 0 auto;
  height: 54px;
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  align-items: center;
  margin-bottom: 40px;
}

.indexTeachers .classesTitle img {
  display: inline-block;
  width: 54px;
  height: 54px;
  margin-right: 12px;
}

.indexTeachers .classesTitle h2 {
  display: inline-block;
  color: #003399;
  font-size: 28px;
  font-weight: bold;
  margin-right: 130px;
}

.indexTeachers .teacherSwiper {
  width: 1300px;
  max-height: 750px;
  margin: 0 auto;
}

.indexTeachers .teacherSwiper .swiper-slide {
  display: block;
  width: 100%;
  height: 100%;
  padding-left: 50px;
  padding-right: 50px;
  padding-top: 20px;
  padding-bottom: 20px;
  font-size: 0;
}

.indexTeachers .teacherSwiper .swiper-pagination {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 9999;
  text-align: center;
}

.indexTeachers .teacherSwiper .swiper-pagination .swiper-pagination-bullet {
  width: 26px;
  height: 6px;
  display: inline-block;
  border-radius: 3px;
  background-color: rgba(167, 167, 167, 0.75);
  margin-right: 6px;
  transition: all 0.4s;
}

.indexTeachers .teacherSwiper .swiper-pagination .swiper-pagination-bullet-active {
  width: 40px;
  height: 6px;
  border-radius: 3px;
  background-color: rgba(0, 51, 153, 1);
}

.indexTeachers .teacherItem {
  display: inline-block;
  width: 280px;
  height: 320px;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.0800);
  margin-right: 26px;
  margin-bottom: 30px;
  position: relative;
  z-index: 1;
  background-color: #fff;
  padding: 26px 27px;
  overflow: hidden;
  text-overflow: ellipsis;
}

.indexTeachers .teacherItem:nth-child(4n) {
  margin-right: 0;
}

.indexTeachers .teacherItem .bg {
  width: 280px;
  height: 101px;
  position: absolute;
  z-index: -1;
  top: 0;
  left: 0;
  right: 0;
}

.indexTeachers .teacherItem .teacherAvatar {
  width: 130px;
  height: 130px;
  display: block;
  margin: 0 auto;
  margin-bottom: 20px;
  object-fit: cover;
  border-radius: 100%;
}

.indexTeachers .teacherItem b {
  display: block;
  color: #151515;
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 14px;
  text-align: center;
}

.indexTeachers .teacherItem span {
  display: block;
  text-align: center;
  color: #737373;
  font-size: 14px;
  line-height: 24px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 4;
}
</style>